import { render, staticRenderFns } from "./AuthorItemConfirmDialog.vue?vue&type=template&id=80b133d4&scoped=true"
import script from "./AuthorItemConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./AuthorItemConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./AuthorItemConfirmDialog.vue?vue&type=style&index=0&id=80b133d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b133d4",
  null
  
)

export default component.exports